import { useStyletron } from 'baseui';
import { hexToRGB } from '@gtintel/platform-utils';
const DatePill = ({
  date,
  colour,
  title
}) => {
  const [css] = useStyletron();
  return <div data-testid={`date-pill-${date}`} className={css({
    background: hexToRGB(colour, 0.1),
    borderRadius: '4px',
    color: colour,
    padding: '2px 8px',
    width: 'fit-content'
  })} title={title}>
      <p className={css({
      margin: 0
    })}>
        <strong>{date}</strong>
      </p>
    </div>;
};
export default DatePill;